document.addEventListener("DOMContentLoaded", function () {

    function toggleSubscriptionWarning() {

        const warning = document.getElementById("pw-subscription-warning");

        if (!warning) return;

        const selectedOption = document.querySelector(
            'input[name="paywhirl-plan-selector-group"]:checked'
        );

        if (!selectedOption) {
            warning.style.display = "none";
            return;
        }

        // Subscribe selected
        if (selectedOption.value !== "") {
            warning.style.display = "block";
        } else {
            warning.style.display = "none";
        }

    }

    // Initial state
    toggleSubscriptionWarning();

    // Listen for purchase option changes
    document.body.addEventListener("change", function (event) {

        if (
            event.target.matches(
                'input[name="paywhirl-plan-selector-group"]'
            )
        ) {
            toggleSubscriptionWarning();
        }

    });

});